import React from "react";
import { SmsTosConsentSuccessScreen } from "~/features/tos-consent/SmsTosConsentSuccessScreen";

const Component = () => {
  return <SmsTosConsentSuccessScreen />;
};

export default Component;
